module.exports = __webpack_public_path__ + "img/20260308_1.70732c5a.jpeg";